import {
  FETCH_ALL_MEMBERSHIPS_START,
  CREATE_MEMBERSHIP_START,
  CREATE_MEMBERSHIP_SUCCESS,
  CREATE_MEMBERSHIP_ERROR,
  EDIT_MEMBERSHIP_START,
  EDIT_MEMBERSHIP_SUCCESS,
  EDIT_MEMBERSHIP_ERROR,
  ARCHIVE_MEMBERSHIP_START,
  ARCHIVE_MEMBERSHIP_SUCCESS,
  ARCHIVE_MEMBERSHIP_ERROR,
} from './constants';
import Http from '../../http';

const fetchAllMembershipsStart = () => ({
  type: FETCH_ALL_MEMBERSHIPS_START,
});

const fetchMembership = dispatch => (ownerId, ownerType, membershipId) => {
  dispatch(fetchAllMembershipsStart());

  const url = `/${ownerType}/${ownerId}/memberships/${membershipId}`;
  return Http.get(url);
};

export const fetchBrandMembership = (brandId, membershipId) => (dispatch) => {
  const fetcherFn = fetchMembership(dispatch);
  return fetcherFn(brandId, 'brand', membershipId);
};

export const fetchShopMembership = (shopId, membershipId) => (dispatch) => {
  const fetcherFn = fetchMembership(dispatch);
  return fetcherFn(shopId, 'shop', membershipId);
};

const createMembershipStart = () => ({
  type: CREATE_MEMBERSHIP_START,
});

const createMembershipSuccess = (payload) => ({
  type: CREATE_MEMBERSHIP_SUCCESS,
  payload,
});

const createMembershipError = () => ({
  type: CREATE_MEMBERSHIP_ERROR,
});

const createMembership = dispatch => (ownerId, ownerType, data) => {
  dispatch(createMembershipStart());

  const url = `/${ownerType}/${ownerId}/memberships`;
  return Http.post(url, data)
    .then((res) => {
      dispatch(createMembershipSuccess(res));
      return res;
    })
    .catch((e) => {
      dispatch(createMembershipError());
      throw e;
    });
};

export const createBrandMembership = (brandId, data) => (dispatch) => {
  const creatorFn = createMembership(dispatch);
  return creatorFn(brandId, 'brand', data);
};

export const createShopMembership = (shopId, data) => (dispatch) => {
  const creatorFn = createMembership(dispatch);
  return creatorFn(shopId, 'shop', data);
};

const editMembershipStart = () => ({
  type: EDIT_MEMBERSHIP_START,
});

const editMembershipSuccess = (payload) => ({
  type: EDIT_MEMBERSHIP_SUCCESS,
  payload,
});

const editMembershipError = () => ({
  type: EDIT_MEMBERSHIP_ERROR,
});

const editMembership = dispatch => (ownerId, ownerType, data) => {
  dispatch(editMembershipStart());

  const url = `/${ownerType}/${ownerId}/memberships/${data.id}`;
  return Http.put(url, data)
    .then((res) => {
      dispatch(editMembershipSuccess(res));
      return res;
    })
    .catch((e) => {
      dispatch(editMembershipError());
      throw e;
    });
};

export const editBrandMembership = (brandId, data) => (dispatch) => {
  const creatorFn = editMembership(dispatch);
  return creatorFn(brandId, 'brand', data);
};

export const editShopMembership = (shopId, data) => (dispatch) => {
  const creatorFn = editMembership(dispatch);
  return creatorFn(shopId, 'shop', data);
};

const archiveMembershipStart = () => ({
  type: ARCHIVE_MEMBERSHIP_START,
});

const archiveMembershipSuccess = (payload) => ({
  type: ARCHIVE_MEMBERSHIP_SUCCESS,
  payload,
});

const archiveMembershipError = () => ({
  type: ARCHIVE_MEMBERSHIP_ERROR,
});

const archiveMembership = dispatch => (ownerId, ownerType, data) => {
  dispatch(archiveMembershipStart());

  const url = `/${ownerType}/${ownerId}/memberships/${data.id}`;
  return Http.delete(url)
    .then((res) => {
      dispatch(archiveMembershipSuccess(res));
      return res;
    })
    .catch((e) => {
      dispatch(archiveMembershipError());
      throw e;
    });
};

export const archiveBrandMembership = (brandId, data) => (dispatch) => {
  const creatorFn = archiveMembership(dispatch);
  return creatorFn(brandId, 'brand', data);
};

export const archiveShopMembership = (shopId, data) => (dispatch) => {
  const creatorFn = archiveMembership(dispatch);
  return creatorFn(shopId, 'shop', data);
};

const copyMembership = (ownerId, ownerType, data) => {
  const url = `/${ownerType}/${ownerId}/memberships/${data.id}/copy`;
  return Http.post(url);
};

export const copyBrandMembership = (brandId, data) => () => {
  return copyMembership(brandId, 'brand', data);
};

export const copyShopMembership = (shopId, data) => () => {
  return copyMembership(shopId, 'shop', data);
};

export const assignMemberships = (brandId, membershipId, assignees) => (
  Http.post(`/brand/${brandId}/memberships/${membershipId}/assign`, { assignees })
);

export const fetchShopMembershipsStats = (shopId) => (
  Http.get(`/shop/${shopId}/memberships/summary`)
);
